import { getAllDistrictsFail, getAllDistrictsStart, getAllDistrictsSuccess } from "../constants/districts";

const initialState = {
  isProcessing: false,
  isError: false,
  data: null
}

function handleReducer(state = initialState, action){
  switch(action.type) {
    case getAllDistrictsStart:
      return {...state, isProcessing: true};

    case getAllDistrictsFail:
      return {...state, isError: true, isProcessing: false};

    case getAllDistrictsSuccess:
      return {...state, data: action.payload, isProcessing: false}

    default:
      return state;
  }
}

export const districtsReducer = (state, action) => {
  return handleReducer(state, action);
}